import { CustomDomainsApi, DNSRecord } from '@va/shared/api/custom-domains';
import { useCallback, useState } from 'react';

export const useVerifyDNSRecords = () => {
  const [isLoading, setIsLoading] = useState(false);

  const verify = useCallback(async ({ dnsRecords, domain }: { dnsRecords: DNSRecord[]; domain: string }) => {
    setIsLoading(true);

    const requests: Promise<any>[] = [];
    dnsRecords.forEach((record) => {
      let host: string;
      if (record.name === '@') {
        host = domain;
      } else {
        host = record.name + '.' + domain;
      }

      requests.push(
        CustomDomainsApi.checkDNS({
          expectedValue: record.value,
          host: host,
          type: record.type,
        }),
      );
    });

    const responses = await Promise.allSettled(requests);
    const statusMap: Record<number, boolean> = {};
    let someFailed = false;

    responses.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        statusMap[index] = true;
      } else {
        statusMap[index] = false;
        someFailed = true;
      }
    });

    setIsLoading(false);
    return { statusMap, someFailed };
  }, []);

  return { verify, isLoading };
};
